import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getAllWebhookLogs } from "../../../data/requests/webhooklog-requests";
import { AdminLayout } from "../shared/layout";
import { Badge } from "@/components/ui/badge";
import { DataTable } from "@/components/table";
import { CheckCircle, XCircle } from "lucide-react";

export function WebhookLogListScreen() {
  const [success, setSuccess] = useState("");

  const { data, isLoading } = useQuery({
    queryKey: ["admin-webhook-logs", { success }],
    queryFn: () => getAllWebhookLogs({ success }).then(res => res.data),
  });

  const columns = [
    { key: "id", label: "ID" },
    {
      key: "user",
      label: "User",
      render: (row) => row.user?.email || "—",
    },
    {
      key: "requestMethod",
      label: "Method",
      render: (row) => (
        <Badge variant="outline">{row.requestMethod}</Badge>
      ),
    },
    {
      key: "requestUrl",
      label: "URL",
      render: (row) => (
        <span className="text-sm truncate max-w-xs block" title={row.requestUrl}>
          {row.requestUrl}
        </span>
      ),
    },
    {
      key: "responseStatus",
      label: "Status",
      render: (row) => row.responseStatus || "—",
    },
    {
      key: "duration",
      label: "Duration",
      render: (row) => row.duration ? `${row.duration}ms` : "—",
    },
    {
      key: "success",
      label: "Result",
      render: (row) => (
        <Badge variant={row.success ? "success" : "destructive"}>
          {row.success ? (
            <>
              <CheckCircle className="mr-1 h-3 w-3" />
              Success
            </>
          ) : (
            <>
              <XCircle className="mr-1 h-3 w-3" />
              Failed
            </>
          )}
        </Badge>
      ),
    },
    {
      key: "createdAt",
      label: "Time",
      render: (row) => new Date(row.createdAt).toLocaleString(),
    },
  ];

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">All Webhook Logs</h1>
          <p className="text-gray-500 mt-2">
            Monitor all webhook requests across all users
          </p>
        </div>

        <DataTable
          data={data?.logs || []}
          columns={columns}
          isLoading={isLoading}
        />
      </div>
    </AdminLayout>
  );
}

